import React from "react";
import { Navbar, Nav, Container, Dropdown } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";

import "./Header.css";
import { useAuth } from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useLocationContext } from "../../Context/LocationContext";
const Header = ({ scrollToMobile }) => {
  const { isLoggedIn, logout } = useAuth();
  const { location } = useLocationContext();
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    navigate("/");
  };
  const handleLoginClick = (e) => {
    e.preventDefault();

    if (window.location.pathname === "/") {
      scrollToMobile && scrollToMobile();
    } else {
      navigate("/");
      setTimeout(() => {
        scrollToMobile && scrollToMobile();
      }, 300);
    }
  };

  return (
    <>
      <Navbar expand="lg" className="custom-navbar">
        <Container fluid>
          <Navbar.Brand
            onClick={() => {
              navigate("/");
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            style={{ cursor: "pointer" }}
          >
            <img
              src={require("../../Assets/header-logo.png")}
              alt="Logo"
              height="40"
              className="d-inline-block align-top"
            />
          </Navbar.Brand>

          <div className="address" style={{ cursor: "pointer" }}>
            <span className="location-svg">
              <svg
                width="12.5"
                height="16"
                viewBox="0 0 11 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.13086 13.8026L5.50242 13.2725L5.87333 13.8033C5.76446 13.8793 5.63481 13.9201 5.50199 13.92C5.36917 13.9199 5.2396 13.8789 5.13086 13.8026Z"
                  fill="#FDB900"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.50235 2.91284C4.81564 2.91284 4.15705 3.18564 3.67146 3.67122C3.18588 4.1568 2.91309 4.81539 2.91309 5.50211C2.91309 6.18882 3.18588 6.84741 3.67146 7.33299C4.15705 7.81858 4.81564 8.09137 5.50235 8.09137C6.18907 8.09137 6.84766 7.81858 7.33324 7.33299C7.81882 6.84741 8.09162 6.18882 8.09162 5.50211C8.09162 4.81539 7.81882 4.1568 7.33324 3.67122C6.84766 3.18564 6.18907 2.91284 5.50235 2.91284ZM4.20772 5.50211C4.20772 5.15875 4.34412 4.82945 4.58691 4.58666C4.8297 4.34387 5.15899 4.20747 5.50235 4.20747C5.84571 4.20747 6.175 4.34387 6.41779 4.58666C6.66059 4.82945 6.79698 5.15875 6.79698 5.50211C6.79698 5.84547 6.66059 6.17476 6.41779 6.41755C6.175 6.66034 5.84571 6.79674 5.50235 6.79674C5.15899 6.79674 4.8297 6.66034 4.58691 6.41755C4.34412 6.17476 4.20772 5.84547 4.20772 5.50211Z"
                  fill="#FDB900"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.13063 13.8001L5.50219 13.27C5.8731 13.8008 5.8744 13.7995 5.8744 13.7995L5.87569 13.7988L5.87957 13.7963L5.89252 13.7865L5.93783 13.7542L6.10419 13.6299C6.94421 12.9797 7.71922 12.2495 8.41835 11.4497C9.66896 10.0107 11.0044 7.91992 11.0044 5.50219C11.0044 4.04292 10.4247 2.64341 9.39283 1.61155C8.36096 0.579693 6.96146 0 5.50219 0C4.04292 0 2.64341 0.579693 1.61155 1.61155C0.579693 2.64341 0 4.04292 0 5.50219C0 7.91992 1.33541 10.0107 2.58603 11.4491C3.28514 12.2491 4.06015 12.9794 4.90019 13.6299C4.97 13.6831 5.04056 13.7353 5.11186 13.7865L5.1248 13.7963L5.12869 13.7988L5.13063 13.8001ZM2.52712 2.52712C3.11556 1.93874 3.86525 1.53805 4.6814 1.37572C5.49756 1.21339 6.34352 1.29671 7.11232 1.61515C7.88112 1.93359 8.53823 2.47284 9.00056 3.16473C9.4629 3.85661 9.7097 4.67005 9.70975 5.50219C9.70975 7.45385 8.61772 9.24691 7.4409 10.5998C6.85093 11.2752 6.20214 11.8969 5.50219 12.4576C4.80226 11.8972 4.15347 11.2757 3.56348 10.6005C2.38666 9.24627 1.29463 7.4532 1.29463 5.50219C1.2947 4.3863 1.73804 3.31614 2.52712 2.52712Z"
                  fill="#FDB900"
                />
              </svg>
            </span>
            <div className="address-select">
              {location.browsing_address
                ? location.browsing_address.length > 35
                  ? location.browsing_address.slice(0, 35) + "..."
                  : location.browsing_address
                : "Select your location"}
            </div>
          </div>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-center"
          >
            <Nav>
              {isLoggedIn ? (
                <>
                  <NavLink
                    to="/user-profile/profile"
                    className={({ isActive }) =>
                      isActive ? "nav-link active-link" : "nav-link"
                    }
                  >
                    Profile
                  </NavLink>
                  <div
                    className="nav-link"
                    onClick={handleLogout}
                    style={{ cursor: "pointer" }}
                  >
                    <FiLogOut className="me-1" style={{ color: "red" }} />
                    Logout
                  </div>
                </>
              ) : (
                <>
                  <NavLink
                    to="/"
                    onClick={handleLoginClick}
                    className={({ isActive }) =>
                      isActive ? "nav-link active-link" : "nav-link"
                    }
                  >
                    Login
                  </NavLink>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
